// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ePrD","index":"styles_index__2YjRZ"};